import { render } from "./DeepPerformanceGpuPerformance.vue?vue&type=template&id=0db90f47&scoped=true&ts=true"
import script from "./DeepPerformanceGpuPerformance.vue?vue&type=script&lang=ts"
export * from "./DeepPerformanceGpuPerformance.vue?vue&type=script&lang=ts"

import "./DeepPerformanceGpuPerformance.vue?vue&type=style&index=0&id=0db90f47&scoped=true&lang=css"
import "./DeepPerformanceGpuPerformance.vue?vue&type=style&index=1&id=0db90f47&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db90f47"]])

export default __exports__